import React, { Component } from 'react';
import {
  Button, Col, Card, CardBody, Table, Row, UncontrolledTooltip,
} from 'reactstrap';
import { Link, Redirect } from 'react-router-dom';
import Moment from 'moment';
import parse from 'html-react-parser';
import swal from 'sweetalert';

import TransactionModal from '../../Transactions/components/TransactionModal';
import ProductListsModal from '../../Transactions/components/ProductListsModal';
import StoreReportModal from '../../Stocks/components/StoreReportModal';
import CommonService from '../../../services/CommonService';
import global from '../../../global';

class StoreDashboard extends Component {
  constructor() {
    super();
    this.userData = JSON.parse(localStorage.getItem('userData'));
    this.state = {
      modal: false,
      formdata: {
        customer: '',
        product: {},
      },
      errorMsg: '',
      list: false,
      currentDate: Moment(new Date()).format('MMMM DD, YYYY'),
      goTo: false,
      goToPage: '/',
    };
    this.locationID = this.userData.location_id;
    this.isLoading = false;
    this.toggleModal = this.toggleModal.bind(this);
    this.addToggle = this.addToggle.bind(this);
    this.toggleReport = this.toggleReport.bind(this);
    this.userdata = JSON.parse(localStorage.getItem('userData'));
  }

  componentDidMount() {
    this.isLoading = true;
    this.onLoadData();
  }

  componentWillUnmount() {
    this.isLoading = false;
  }

  async onLoadData() {
    try {
      const sdate = Moment(new Date()).format('YYYY-MM-DD');
      const response = await CommonService.getRows(`storedashboard/locationid/${this.userdata.location_id}/salesdate/${sdate}`);
      if (this.isLoading && (response !== false || response !== '')) {
        this.setState({
          list: response.sales,
          totalSales: {
            daily: response.daily,
            weekly: response.weekly,
            monthly: response.monthly,
          },
        });
      }
    } catch (err) {
      console.log('Error: ', err.message);
      this.isLoading = false;
    }
  }

  handleChange = (e, fieldname = '') => {
    if (fieldname === 'number') {
      const { name, value } = e.target;
      this.setState(prevState => ({
        formdata: { ...prevState.formdata, product: { ...prevState.formdata.product, [name]: value.replace(/[^0-9.]/g, '') } },
      }));
    } else if (fieldname === 'async') {
      this.setState(prevState => ({
        formdata: { ...prevState.formdata, product: { productVal: e.value, productName: e.label } },
      }));
    } else {
      const { name, value } = e.target;
      this.setState(prevState => ({
        formdata: { ...prevState.formdata, [name]: value },
      }));
    }
  }

  goTo = (ev) => {
    this.setState({ goTo: true, goToPage: ev.currentTarget.dataset.href });
  }

  addTransaction(e) {
    e.preventDefault();
    const form = document.getElementById('store_transaction_form');
    const formdata = new FormData(form);
    formdata.append('location_id', this.userdata.location_id);
    formdata.append('user_id', this.userdata.user_id);

    CommonService.insertData('addstoretransaction', formdata, false).then((result) => {
      if (result.msg === true) {
        // update list
        this.onLoadData();
        this.setState({ errorMsg: '', modal: false });

        swal({
          title: 'Successfully added transaction!',
          text: 'Add new transaction?',
          icon: 'warning',
          closeOnClickOutside: false,
          buttons: {
            yes: 'ADD NEW',
            no: 'NOPE',
          },
        }).then((name) => {
          name = name.toLowerCase();

          if (name === 'yes') {
            this.addToggle();
          }
        });
      } else {
        this.setState({ errorMsg: result.msg });
      }
    }).catch((err) => {
      console.log('Error: ', err.message);
    });
  }

  submitReport(e) {
    e.preventDefault();
    const form = document.getElementById('store_daily_report');
    const formdata = new FormData(form);
    formdata.append('location_id', this.userdata.location_id);
    formdata.append('user_id', this.userdata.user_id);

    CommonService.insertData('storedailyreport', formdata, false).then((result) => {
      if (result.msg === true) {
        window.location.reload();
      } else {
        this.setState({ errorMsg: result.msg });
      }
    }).catch((err) => {
      console.log('Error: ', err.message);
    });
  }

  addToggle() {
    this.toggleModal();
    this.executeModal = 'addtransaction';
    this.handleSubmit = (e) => { this.addTransaction(e); };
  }

  toggleReport() {
    this.toggleModal();
    this.executeModal = 'submitreport';
    this.handleSubmit = (e) => { this.submitReport(e); };
  }

  viewproducts(e, paramdata) {
    e.preventDefault();
    const {
      salesid, total, amountPaid, balance,
    } = paramdata;
    this.executeModal = 'viewproducts';
    this.toggleModal();
    this.setState({
      salesid, total, amountPaid, balance,
    });
  }

  toggleModal() {
    this.setState(prevState => ({ modal: !prevState.modal }));
  }

  render() {
    const {
      modal, formdata, errorMsg, list, salesid, total, amountPaid, balance, totalSales, currentDate, goTo, goToPage,
    } = this.state;

    if (goTo === true) {
      return <Redirect to={{ pathname: goToPage, state: { prevpage: '/dashboard' } }} />;
    }

    return (
      <Row className="p-t-15">
        {
          this.executeModal === 'addtransaction' ? (
            <TransactionModal
              title="Add Transaction"
              modal={modal}
              toggle={this.toggleModal}
              handleChange={this.handleChange}
              handleSubmit={this.handleSubmit}
              postValue={formdata}
              errorMsg={errorMsg}
            />
          ) : this.executeModal === 'submitreport' ? (
            <StoreReportModal
              title="Add Transaction"
              modal={modal}
              toggle={this.toggleModal}
              handleSubmit={this.handleSubmit}
              errorMsg={errorMsg}
            />
          ) : this.executeModal === 'viewproducts' ? (
            <ProductListsModal
              salesId={salesid}
              toggle={this.toggleModal}
              modal={modal}
              total={total}
              amountPaid={amountPaid}
              balance={balance}
            />
          ) : ''
        }

        <Col md={8} className="col-left">
          <Card className="panel panel--primary" id="users_table">
            <CardBody className="panel__body">
              <div className="panel__title bg_blue">
                <h5 className="bold-text">
                  <span className="v-middle">Daily Sales</span>
                  <span className="text-blue m-l-10 v-middle">({currentDate})</span>
                </h5>
                <div className="panel__btns">
                  <Link to="/transactions" className="rounded btn btn-primary btn-sm btn-awesome"><span className="fa fa-eye" /> View More</Link>
                </div>
              </div>
              <div className="panel__content">
                <Table responsive hover striped>
                  <thead>
                    <tr>
                      <th>Customer</th>
                      <th className="text-center">Total</th>
                      <th className="text-center">Amount Paid</th>
                      <th className="text-center">Balance</th>
                      <th className="text-center">DR Number</th>
                      <th className="text-center">Date</th>
                      <th width="10%" className="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                  {
                    list !== false || list.length > 0 ? list.map((item, i) => {
                      const param = {
                        salesid: item.sales_id,
                        total: item.total,
                        amountPaid: item.amount_paid,
                        balance: item.balance,
                        drNumber: item.dr_number,
                      };
                      const currBalance = parseFloat(item.balance);

                      return (
                        <tr key={`customer_row${i + 1}`} className="text-center">
                          <td className="text-left">{item.customer_name}</td>
                          <td className="text-primary">&#x20B1; {item.total}</td>
                          <td className="text-success">&#x20B1; {item.amount_paid}</td>
                          <td className="text-danger">{currBalance > 0 ? parse(`&#x20B1; ${global.numberFormat(currBalance)}`) : '-'}</td>
                          <td className="text-success">{item.dr_number}</td>
                          <td>{item.date_sales}</td>
                          <td className="text-center">
                            <Button color="primary" className="btn-xs" onClick={e => this.viewproducts(e, param)} id={`viewprodbtn${i + 1}`} outline><span className="fa fa-eye" /></Button>
                            <UncontrolledTooltip placement="bottom" target={`viewprodbtn${i + 1}`}>View Products</UncontrolledTooltip>
                          </td>
                        </tr>
                      );
                    }) : (
                      <tr className="text-center">
                        <td colSpan="7">No data available..</td>
                      </tr>
                    )
                  }
                  </tbody>
                </Table>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col md={4} className="col-right">
          <div id="children-pane">
            <Button onClick={this.addToggle} color="primary" className="rounded btn-block" size="lg"><i className="fa fa-plus-circle m-r-10" />&nbsp; ADD NEW TRANSACTION</Button>
            <Button onClick={this.toggleReport} color="danger" className="rounded btn-block" size="lg"><i className="fa fa-clipboard-check m-r-10" />&nbsp; SUBMIT DAILY SALES REPORT</Button>
          </div>
          <div className="stock-box__container stock-lg stock-block stock_magic">
            <Button className="stock-box stock-aqua m-b-20" onClick={this.goTo} data-href={`/stockstracker/${this.locationID}/stocksold/list`}>
              <div className="stock-box__icon"><i className="fa fa-chart-line" /></div>
              <h3 className="stock-box__num">Daily Sales</h3>
              <h4 className="stock-box__text"><span className="m-r-2">&#x20B1;</span> {totalSales && !Number.isNaN(totalSales.daily) ? totalSales.daily : 0.00}</h4>
            </Button>
            <div className="stock-box stock-blue m-b-20">
              <div className="stock-box__icon"><i className="fa fa-calendar-minus" /></div>
              <h3 className="stock-box__num">Weekly Sales</h3>
              <h4 className="stock-box__text"><span className="m-r-2">&#x20B1;</span> {totalSales && !Number.isNaN(totalSales.weekly) ? totalSales.weekly : 0.00}</h4>
            </div>
            <div className="stock-box stock-pink m-b-20">
              <div className="stock-box__icon"><i className="fa fa-calendar-alt" /></div>
              <h3 className="stock-box__num">Monthly Sales</h3>
              <h4 className="stock-box__text"><span className="m-r-2">&#x20B1;</span> {totalSales && !Number.isNaN(totalSales.monthly) ? totalSales.monthly : 0.00}</h4>
            </div>
          </div>
        </Col>
      </Row>
    );
  }
}

export default StoreDashboard;
